export enum LabelVariant {
    caption = "caption",
    pageTitle = "pageTitle",
    sectionHeading = "sectionHeading"
}

export class LabelVariantUtil {
    public static getThemeKey(variant: LabelVariant): string {
        switch (variant) {
            case LabelVariant.caption:
                return "label.variants.caption";
            case LabelVariant.pageTitle:
                return "label.variants.pageTitle";
            case LabelVariant.sectionHeading:
                return "label.variants.sectionHeading";
            default:
                return null;
        }
    }
}
